import { createNanoEvents } from "nanoevents";

export type TWarningModalProps = {
  handleSessionStart: () => void;
};

interface Events {
  OPEN_WARNING_MODAL: (payload: TWarningModalProps) => void;
  CLOSE_WARNING_MODAL: () => void;
}

export const emitter = createNanoEvents<Events>();

export type TEventType = keyof Events;
